import { Cookies } from 'react-cookie';

import { CompanyPestResponse, ClientWithPestCompanyEditValues } from './types';

import { axiosInterceptorForMultipartFromData } from 'api/interceptor/axiosClient';

export const updateCompanyPest = async ({
  client,
}: {
  client: ClientWithPestCompanyEditValues;
}): Promise<CompanyPestResponse> => {
  const fd = new FormData();
  if (!client.id) {
    throw new Error('Client ID is required for updating pest company');
  }
  if (client.name) {
    fd.append('name', client.name);
  }
  if (client.ownership_form) {
    fd.append('ownership_form', client.ownership_form);
  }
  if (client.description) {
    fd.append('description', client.description);
  }
  if (client.EDRPOU) {
    fd.append('EDRPOU', client.EDRPOU);
  }
  if (client.zip_code) {
    fd.append('zip_code', client.zip_code);
  }
  if (client.country) {
    fd.append('country', String(client.country));
  }
  if (client.city_text) {
    fd.append('city_text', client.city_text);
  }
  if (client.street) {
    fd.append('street', client.street);
  }
  if (client.building_no) {
    fd.append('building_no', client.building_no);
  }
  if (client.apartment_no) {
    fd.append('apartment_no', client.apartment_no || '');
  }

  if (client.logo instanceof File) {
    fd.append('logo', client.logo);
  }

  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptorForMultipartFromData.put(`service-provider-companies/${client.id}/`, fd, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as CompanyPestResponse;
};
